<template>
  <div @click.stop>
    <van-overlay :show="overlayshow" @click="close" z-index="10240">
      <page-container class="wrapper" :wxShow="false">
        <template v-if="type==1">
            <van-image-preview @close="close" :startPosition="current" v-model="overlayshow" :images="images" @change="onChange">
              <template v-slot:index>第{{ current+1 }}页</template>
            </van-image-preview>
        </template>
        <template v-else-if="type==2">
          <div>
            <video v-if="overlayshow" autoplay class="video" :src="query.item" @click.stop controls></video>
            <img src="../../assets/image/common/video/close.png" alt="" class="close_video">
          </div>
        </template>
      </page-container>
    </van-overlay>
  </div>
</template>

<script>
import { appstyle } from "@/utils/index";
export default {
  props: {
    query: {
      type: Object,
      default: {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      current: 0,
      images:[],
      previewshow:true,
      overlayshow:false,
      type:-1
    };
  },
  computed: {
    appstyle,
  },
  watch: {
    show:{
      handler(val){
        this.overlayshow = val
      }
    },
    query: {
      handler(val) {
        if (val) {
          console.log(val, "val");
          this.type = val.type
          let list = JSON.parse(JSON.stringify(val.list));
          this.current = val.current;
          this.list = list;
          this.images = this.filtration()
        }
      },
      deep: true,
    },
  },
  methods: {
    filtration(type) {
      let arr = []
      this.list.forEach(item=>{
          arr.push(item.cover)
      })
			return arr
		},
    onChange(current) {
      this.current = current;
    },
    close() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper_container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  position: relative;
  .video{
    width: 100%;
    height: 100%;
  }
  .close_video{
    position: absolute;
    z-index: 2;
    width: .4rem /* 30/75 */;
    height: .4rem /* 30/75 */;
    right: .4rem /* 30/75 */;
    top: .4rem /* 30/75 */;
  }

}
::v-deep .van-image-preview__index{
  top: 94% !important;
 
}
</style>
